import { cn } from '@library/component-utils/cn';

export interface ChartKeyProps {
  colorClass?: string;
  graphArea: string;
  quantity?: number | undefined;
}

export const ChartKey = ({
  graphArea,
  colorClass = 'bg-soClean-100',
  quantity = undefined
}: ChartKeyProps) => {
  const formattedQuantity = quantity
    ? new Intl.NumberFormat().format(quantity)
    : 0;

  return (
    <div className="flex items-center gap-2">
      <div className={cn('inline-block h-3 w-3 rounded-sm', colorClass)} />
      <div className="text-soClean-180 text-xs">
        {quantity != null && (
          <span className="text-soClean-100 mr-1 text-sm">
            {formattedQuantity}
          </span>
        )}
        {graphArea}
      </div>
    </div>
  );
};
